const hexEntityPattern = /&#x([0-9A-Fa-f]+);/g;

export const convertHexToChar = (hex: string) => {
  let result = hex;
  if (hexEntityPattern.test(hex)) {
    const decimalCode = parseInt(hex, 16);
    const stringFromChar = String.fromCharCode(decimalCode);
    result = hex.replace(hexEntityPattern, stringFromChar);
  }
  return result;
};
